export function parseDataISO(dataISO: string): { ano: number; mes: number; dia: number } {
  const [ano, mes, dia] = dataISO.split('-').map(Number);
  return { ano, mes, dia };
}

export function formatarDataBR(dataISO: string): string {
  const { ano, mes, dia } = parseDataISO(dataISO);
  return `${String(dia).padStart(2, '0')}/${String(mes).padStart(2, '0')}/${ano}`;
}

export function validarCPF(cpf: string): boolean {
  const limpo = cpf.replace(/\D/g, '');
  if (limpo.length !== 11) return false;
  if (/^(\d)\1+$/.test(limpo)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(limpo[i]) * (10 - i);
  let dv1 = (soma * 10) % 11;
  if (dv1 === 10) dv1 = 0;
  if (dv1 !== parseInt(limpo[9])) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(limpo[i]) * (11 - i);
  let dv2 = (soma * 10) % 11;
  if (dv2 === 10) dv2 = 0;
  return dv2 === parseInt(limpo[10]);
}

export function formatarCPF(cpf: string): string {
  const limpo = cpf.replace(/\D/g, '');
  return limpo.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatarCNPJ(cnpj: string): string {
  const limpo = cnpj.replace(/\D/g, '');
  return limpo.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
}

export function validarCNPJ(cnpj: string): boolean {
  const c = cnpj.replace(/\D/g, '');
  if (c.length !== 14) return false;
  if (/^(\d)\1+$/.test(c)) return false;
  const calc = (tamanho: number): number => {
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += parseInt(c[tamanho - i]) * pos--;
      if (pos < 2) pos = 9;
    }
    const r = soma % 11;
    return r < 2 ? 0 : 11 - r;
  };
  return calc(12) === parseInt(c[12]) && calc(13) === parseInt(c[13]);
}

/** Aceita CPF (11 dígitos) ou CNPJ (14 dígitos), validando o dígito verificador. */
export function validarCPFouCNPJ(doc: string): boolean {
  const d = doc.replace(/\D/g, '');
  if (d.length === 11) return validarCPF(d);
  if (d.length === 14) return validarCNPJ(d);
  return false;
}

/** Formata como CPF (até 11 dígitos) ou CNPJ (12+). */
export function formatarDocumento(doc: string): string {
  const d = doc.replace(/\D/g, '');
  return d.length <= 11 ? formatarCPF(d) : formatarCNPJ(d);
}

export function ehCNPJ(doc: string): boolean {
  return doc.replace(/\D/g, '').length > 11;
}

export interface ColunaCSV {
  chave: string;
  titulo: string;
}

/**
 * Exporta uma lista de registros para CSV (separador ';' + BOM UTF-8 — abre direto no Excel pt-BR)
 * e dispara o download no navegador. Atende a exigência do TR de exportação nativa em todos os módulos.
 */
export function exportarCSV(
  nomeArquivo: string,
  colunas: ColunaCSV[],
  linhas: Array<Record<string, unknown>>,
): void {
  const esc = (v: unknown) => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[";\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const header = colunas.map((c) => esc(c.titulo)).join(';');
  const body = linhas.map((l) => colunas.map((c) => esc(l[c.chave])).join(';')).join('\r\n');
  const csv = `﻿${header}\r\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nomeArquivo.endsWith('.csv') ? nomeArquivo : `${nomeArquivo}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function gerarNumeroDocumento(prefixo: string, sequencial: number, ano: number): string {
  return `${prefixo}-${String(sequencial).padStart(4, '0')}/${ano}`;
}
